<template>
  <b-modal 
    ref="modal" 
    id="modal-detalhamento-impostos" 
    size="lg" 
    hide-header
    hide-footer
    body-class="p-0 overflow-hidden"
    content-class="border-0 shadow-lg"
    centered
  >
    <!-- Cabeçalho Premium -->
    <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #2c3e50 0%, #000000 100%) !important;">
      <div class="header-icon-wrapper-modal mr-3 bg-white-100">
        <i class="fa fa-university text-info"></i>
      </div>
      <div>
        <h5 class="mb-0 font-weight-bold text-white">Detalhamento de Impostos</h5>
        <small class="text-white opacity-75">Resumo tributário estadual e federal da NF-e</small>
      </div>
      <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="hide">
        <i class="fa fa-times fa-lg"></i>
      </b-button>
    </div>

    <div class="p-4 bg-white">
      <div class="modal-section-title mb-3">
        <i class="fa fa-map-marker mr-2 text-primary"></i> Tributos e Impostos Estaduais
      </div>
      <b-row class="mb-4">
        <b-col sm="3">
          <label class="modal-label-premium">BC. ICMS</label>
          <vue-autonumeric :value="nfe.VL_BASE_CALC_ICMS" :disabled="true" :options="autonumericOptions" class="form-control rounded-pill shadow-xs bg-light text-right font-weight-bold" />
        </b-col>
        <b-col sm="3">
          <label class="modal-label-premium">Total ICMS</label>
          <vue-autonumeric :value="nfe.VL_TOTAL_ICMS" :disabled="true" :options="autonumericOptions" class="form-control rounded-pill shadow-xs bg-light text-right font-weight-bold text-info" />
        </b-col>
        <b-col sm="3">
          <label class="modal-label-premium">BC. ICMS ST</label>
          <vue-autonumeric :value="nfe.VL_BASE_CALC_ST_ICMS" :disabled="true" :options="autonumericOptions" class="form-control rounded-pill shadow-xs bg-light text-right font-weight-bold" />
        </b-col>
        <b-col sm="3">
          <label class="modal-label-premium">Total ICMS ST</label>
          <vue-autonumeric :value="nfe.VL_TOTAL_ST_ICMS" :disabled="true" :options="autonumericOptions" class="form-control rounded-pill shadow-xs bg-light text-right font-weight-bold text-info" />
        </b-col>
      </b-row>

      <div class="modal-section-title mb-3">
        <i class="fa fa-balance-scale mr-2 text-primary"></i> Tributos e Impostos Federais
      </div>
      <b-row class="mb-4">
        <b-col sm="4">
          <label class="modal-label-premium">Total IPI</label>
          <vue-autonumeric :value="nfe.VL_TOTAL_IPI" :disabled="true" :options="autonumericOptions" class="form-control rounded-pill shadow-xs bg-light text-right font-weight-bold" />
        </b-col>
        <b-col sm="4">
          <label class="modal-label-premium">Total PIS</label>
          <vue-autonumeric :value="nfe.VL_TOTAL_PIS" :disabled="true" :options="autonumericOptions" class="form-control rounded-pill shadow-xs bg-light text-right font-weight-bold text-primary" />
        </b-col>
        <b-col sm="4">
          <label class="modal-label-premium">Total COFINS</label>
          <vue-autonumeric :value="nfe.VL_TOTAL_COFINS" :disabled="true" :options="autonumericOptions" class="form-control rounded-pill shadow-xs bg-light text-right font-weight-bold text-primary" />
        </b-col>
      </b-row>

      <div class="modal-section-title mb-3">
        <i class="fa fa-plus-circle mr-2 text-primary"></i> Outros Valores e Adicionais
      </div>
      <b-row>
        <b-col sm="3">
          <label class="modal-label-premium">Total Desconto</label>
          <vue-autonumeric :value="nfe.VL_TOTAL_DESCONTO" :disabled="true" :options="autonumericOptions" class="form-control rounded-pill shadow-xs bg-light text-right font-weight-bold text-danger" />
        </b-col>
        <b-col sm="3">
          <label class="modal-label-premium">Total Seguro</label>
          <vue-autonumeric :value="nfe.VL_TOTAL_SEGURO" :disabled="true" :options="autonumericOptions" class="form-control rounded-pill shadow-xs bg-light text-right" />
        </b-col>
        <b-col sm="3">
          <label class="modal-label-premium">Total Frete</label>
          <vue-autonumeric :value="nfe.VL_TOTAL_FRETE" :disabled="true" :options="autonumericOptions" class="form-control rounded-pill shadow-xs bg-light text-right" />
        </b-col>
        <b-col sm="3">
          <label class="modal-label-premium">Outras Despesas</label>
          <vue-autonumeric :value="nfe.VL_TOTAL_OUTRAS_DESP" :disabled="true" :options="autonumericOptions" class="form-control rounded-pill shadow-xs bg-light text-right" />
        </b-col>
      </b-row>
    </div>

    <div class="modal-footer-premium p-3 bg-light border-top text-right">
      <b-button variant="soft-danger" pill class="px-5 font-weight-bold" @click="hide">
        FECHAR
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import VueAutonumeric from 'vue-autonumeric'

export default {
  name: 'NfeImpostosModal',
  components: { VueAutonumeric },
  props: {
    nfe: { type: Object, required: true }
  },
  data() {
    return {
      autonumericOptions: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        roundingMethod: 'U',
        minimumValue: '0',
        currencySymbol: 'R$ ',
        currencySymbolPlacement: 'p'
      }
    }
  },
  methods: {
    show() { this.$refs.modal.show() },
    hide() { this.$refs.modal.hide() }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/faturamento/nfe/partials/NfeImpostosModal.vue